module.exports = __webpack_public_path__ + "static/media/15_r_lampa_80.52_7.87.bea7b79d.png";